import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default function useClientTranslation() {
    const { t } = useTranslation();
    const { form: { lang: clientLang = 'en-US' } = {} } = useSelector(state => state.settings);
    return useCallback(id => t(id, { lng: clientLang }), [t, clientLang]);
}
